import { LitElement, html, svg } from 'lit';

export class IconLinkExternal16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Kvadrat med pil opp mot høyre</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 1 8 8M11.04 1H15v3.96M7 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9"></path></svg>`; }
}
if (!customElements.get('f-icon-link-external16', IconLinkExternal16)) {
  customElements.define('f-icon-link-external16', IconLinkExternal16);
}